//------------------------
// apply weapon usability
//------------------------
import { evaluateWeaponUsability } from './weaponUsabilityCore'

export default function applyWeaponUsability(
  item,
  static_item,
  character,
  strCur,
  dexCur,
  effectiveItemType = null,
) {
  console.log('----------------------------------------------')
  console.log('IN applyWeaponUsability for item = ', item.name)

  console.log('0. strCur = ', strCur, ', dexCur = ', dexCur)
  const itemType = effectiveItemType ?? static_item?.type

  // --------------------------------------------------------------------------
  // defaults for weapon usability/requirements
  item.usable_status = 'No'

  if (!static_item || (itemType !== 'Melee Weapon' && itemType !== 'Ranged Weapon')) {
    return
  }

  const characterSkills = Array.isArray(character?.skills) ? character.skills : []
  const staticSkills = Array.isArray(static_item.skills) ? static_item.skills : []

  console.log('characterSkills = ', characterSkills)
  console.log('staticSkills = ', staticSkills)

  const result = evaluateWeaponUsability({
    staticSkills,
    characterSkills,
    itemType,
    strCur,
    dexCur,
  })

  item.min_str = result.minStrReq
  item.min_dex = result.minDexReq
  item.usable_status = result.usable_status
  item.unusable_reasons = result.unusable_reasons

  // --------------------------------------------------------------
  // Broken items are always treated as unusable and the tooltip
  // must explicitly state this so the usable_image column reflects
  // either unusable reasons OR a broken state.
  // --------------------------------------------------------------
  if (item.broken) {
    const brokenText = 'ITEM BROKEN'

    // broken items are always fully unusable (never Partial)
    // so force usable_status hard to 'No' regardless of the
    // computed result from evaluateWeaponUsability.
    item.usable_status = 'No'

    // ensure unusable_reasons includes the broken message
    if (!item.unusable_reasons || item.unusable_reasons.trim() === '') {
      item.unusable_reasons = brokenText
    } else if (!item.unusable_reasons.includes(brokenText)) {
      item.unusable_reasons = `${brokenText}\n${item.unusable_reasons}`
    }
  }

  console.log('2. minStrReq = ', result.minStrReq, ', minDexReq = ', result.minDexReq)
  console.log('10. item.unusable_reasons = ', item.unusable_reasons)

  return item
}
